import React from "react";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";

export default function StatCard({ title, value, change, icon, isPositive }) {
  return (
    <div className="stat-card">
      <div className="stat-card-header">
        <div className="stat-card-icon">{icon}</div>
        <div className="stat-card-title">{title}</div>
      </div>
      <div className="stat-card-body">
        <div className="stat-card-value">{value}</div>
        <div
          className={`stat-card-change ${isPositive ? "positive" : "negative"}`}
        >
          {isPositive ? <FaArrowUp /> : <FaArrowDown />}
          {change}
        </div>
      </div>
    </div>
  );
}
